<template>
    <div>
        <div class="card shadow mb-5">
            <div class="card-header">Contrôle de saisie collaborateur</div>

            <b-card-body>
                <div class="row mb-3">
                    <div class="col-4">
                        <accounting-firm-user-select
                            @collaborator-has-changed="getItems"
                        />
                    </div>
                </div>
                <div v-if="loading">
                    <loading></loading>
                </div>

                <div v-else>
                    <b-alert variant="danger" :show="hasErrors">
                        <span v-html="errorMessage"></span>
                    </b-alert>

                    <b-table
                        responsive
                        small
                        :items="items"
                        :fields="fields"
                        :filter="filter"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        primary-key="id"
                        @filtered="onFiltered"
                    >
                        <template #cell(email)="data">
                            <span
                                v-html="handleTimeSheetEmail(data.item.email)"
                            ></span>
                        </template>
                        <template #cell(sum.billable)="data">
                            <month-charge-handler
                                :charge="{ duration: data.item.sum.billable }"
                            />
                        </template>
                        <template #cell(sum.not_billable)="data">
                            <month-charge-handler
                                :charge="{
                                    duration: data.item.sum.not_billable,
                                }"
                            />
                        </template>
                        <template #cell(sum.absence)="data">
                            <month-charge-handler
                                :charge="{ duration: data.item.sum.absence }"
                            />
                        </template>
                        <template #cell(sum.not_affected)="data">
                            <month-charge-handler
                                :charge="{
                                    duration: data.item.sum.not_affected,
                                }"
                            />
                        </template>
                        <template #cell(sum.duration)="data">
                            <month-charge-handler
                                :charge="{ duration: data.item.sum.duration }"
                            />
                        </template>
                        <template #cell(contractual_week_hours)="data">
                            <month-charge-handler
                                :charge="{
                                    duration: data.item.contractual_week_hours,
                                }"
                            />
                        </template>
                        <template #cell(charge)="data">
                            {{ data.item.charge }}%
                        </template>
                        <template #cell(charge_variant)="data">
                            <b-progress
                                :value="data.item.charge"
                                max="100"
                                :variant="data.item.charge_variant"
                                height="12px"
                                class="mt-1"
                            />
                        </template>
                    </b-table>
                </div>
            </b-card-body>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TableHandler from '../../../common/mixins/TableHandler.vue'
import MonthChargeHandler from '../../../common/components/MonthChargeHandler.vue'
import AccountingFirmUserSelect from './SelectAccountingFirmUser.vue'
import DashboardHandler from '../../../dashboard/mixins/DashboardHandler.vue'
import loading from '../../../common/components/loading.vue'

export default {
    name: 'AccountingFirmUserChargeControl',

    components: {
        AccountingFirmUserSelect,
        MonthChargeHandler,
        loading,
    },

    mixins: [TableHandler, DashboardHandler],

    props: {
        todayY: {
            required: true,
            type: Number,
        },
        todayM: {
            required: true,
            type: Number,
        },
        todayD: {
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            meta: {},
            fields: [
                {
                    key: 'email',
                    label: '',
                    class: 'td-icon',
                },
                {
                    key: 'name',
                    label: 'Semaine',
                    sortable: true,
                },
                {
                    key: 'billable',
                    label: 'Facturable',
                    sortable: true,
                    class: 'text-right col-uniform',
                },
                {
                    key: 'not_billable',
                    label: 'Non facturable',
                    sortable: true,
                    class: 'text-right col-uniform',
                },
                {
                    key: 'absence',
                    label: 'Absence',
                    sortable: true,
                    class: 'text-right col-uniform',
                },
                {
                    key: 'not_affected',
                    label: 'Non affecté',
                    sortable: true,
                    class: 'text-right col-uniform',
                },
                {
                    key: 'duration',
                    label: 'Total saisi',
                    sortable: true,
                    class: 'text-right td-bold col-uniform',
                },
                {
                    key: 'contractual_week_hours',
                    label: 'Contractuel',
                    sortable: true,
                    class: 'text-right col-uniform',
                },
                {
                    key: 'charge',
                    label: 'Taux',
                    sortable: true,
                    class: 'td-bold text-right ',
                },
                {
                    key: 'charge_variant',
                    label: '',
                    class: 'col-uniform',
                },
            ],
        }
    },

    computed: {
        ...mapState({
            accountingFirmUser: (state) =>
                state.timeSheetsVM.filters.accountingFirmUser,
            currentDate: (state) => state.timeSheetsVM.currentDate,
        }),
    },

    async created() {
        this.loading = false
        this.$store.commit(
            'browsing/SET_PAGE_NAME',
            'accountingFirmUserTimeSheetChargeControl'
        )
        this.$store.commit(
            'timeSheetsVM/SET_CURRENT_DATE',
            `${this.todayY}/${this.todayM}/${this.todayD}`
        )
        this.$store.commit('reportingVM/RESET_SEARCH')
        if (this.accountingFirmUser > 0) {
            await this.getItems()
        }
    },

    methods: {
        async getItems() {
            try {
                this.hasErrors = false
                this.loading = true
                const response = await this.$axios.get(
                    `/time-sheets/reporting/accountingFirmUsers/${this.accountingFirmUser}/last-weeks`
                )
                this.items = response.data.data
                this.meta = response.data.meta
                this.loading = false
                this.updateTotalRows()
            } catch (error) {
                // console.log(error)
                this.handleErrors(error.response)
            }
        },
    },
}
</script>

<style scoped></style>
